import PropTypes from 'prop-types'
import React from 'react'

import {
  ContainerContentColumn
} from '../../styled-components'

import { IsLoading } from '../list-items-item'
import { SkeletonPin } from '../../svg-and-Icons'
import { listItemStateVariantOptions } from '../../constants'

const LeftContainerLeadingIcon = ({ leadingIcon, loading, stateStyle, state }) => {
  const leadingIconName =
    leadingIcon?.type?.displayName || leadingIcon?.type?.name

  const isPinComponent = leadingIconName === 'PinsComponent'

  // make a clone of element and apply props
  const leadingIconByState =
    leadingIcon && state === listItemStateVariantOptions.INACTIVE
      ? React.cloneElement(leadingIcon, {
        stroke: stateStyle.iconsColor,
        isInactive: isPinComponent
      })
      : leadingIcon

  return (
    leadingIconByState && (
      <ContainerContentColumn>
        {loading && isPinComponent
          ? (
              SkeletonPin
            )
          : (
          <IsLoading
            skeletonStyle={{
              width: '32px',
              height: '32px',
              borderRadius: '50px'
            }}
          >
            {leadingIconByState}
          </IsLoading>
            )}
      </ContainerContentColumn>
    )
  )
}

LeftContainerLeadingIcon.propTypes = {
  leadingIcon: PropTypes.node,
  loading: PropTypes.bool,
  stateStyle: PropTypes.object,
  state: PropTypes.oneOf(Object.values(listItemStateVariantOptions))
}

export default LeftContainerLeadingIcon
